// apps/tmg-web/components/ui/button-link.tsx
import * as React from "react";
import Link, { type LinkProps } from "next/link";
import { splashButtonVariants, type SplashButtonProps } from "./splash-button";
import { cn } from "@workspace/ui/lib/utils";

export interface ButtonLinkProps
  extends LinkProps,
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href">,
    Pick<SplashButtonProps, "variant" | "size" | "className"> {
  children: React.ReactNode;
}

export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ href, variant, size, className, children, ...props }, ref) => {
    return (
      <Link
        href={href}
        ref={ref}
        className={cn(splashButtonVariants({ variant, size, className }))}
        {...props}
      >
        {children}
      </Link>
    );
  },
);

ButtonLink.displayName = "ButtonLink";
